// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  encounterId: __t.u64().primaryKey().name("encounter_id"),
  worldId: __t.u64().name("world_id"),
  pulse: __t.u32(),
  outcome: __t.u8(),
  at: __t.timestamp(),
  untilPulse: __t.u32().name("until_pulse"),
});
